export const UPDATE_COMPLETE = "UPDATE_COMPLETE"
export const UPDATE_PARTIAL = "UPDATE_PARTIAL"
export const UPDATE_PRE_GLOTIO = "UPDATE_PRE_GLOTIO"
export const NOT_UPDATE_PRE_GLOTIO = "NOT_UPDATE_PRE_GLOTIO"